
import { PropType, computed, defineComponent } from 'vue';

import { TypeSize } from './modal';

export default defineComponent({
  name: 'SModal',
  props: {
    size: {
      required: false,
      type: String as PropType<TypeSize>,
      default: 'middle',
    },
    rightIconClose: {
      required: false,
      type: Boolean,
      default: true,
    },
    title: {
      required: false,
      type: String,
      default: '',
    },
    withHeader: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close'],
  setup(props, { slots, attrs }) {
    const classes = computed(() => {
      let result = 's-modal ';
      result += `${props.size === 'extra-small' ? 's-modal--extra-small' : ''}`;
      result += `${props.size === 'small' ? 's-modal--small' : ''}`;
      result += `${props.size === 'middle' ? 's-modal--middle' : ''}`;
      result += `${props.size === 'large' ? 's-modal--large' : ''}`;
      result += `${props.size === 'extra-large' ? 's-modal--extra-large' : ''}`;
      return result;
    });

    return { classes, slots };
  },
});
